import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

export const hbaseAuthTypes = {
    Anonymous: 'Anonymous',
    Basic: 'Basic'
};

@Metamodel.model({
    name: 'HBase',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.HBase_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.HBase_DisplayText)
    ]
})
export class HbaseLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number = 443;

    @Metamodel.attribute({
        display: stringResources.ModelName_HttpPath
    })
    public httpPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableSSL
    })
    public enableSsl?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ModelName_TrustedCertPath
    })
    public trustedCertPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowHostNameCNMismatch
    })
    public allowHostNameCNMismatch?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowSelfSignedServerCert
    })
    public allowSelfSignedServerCert?: string;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
